<kfm-card [cardTitle]="cardTitle" [cardIcon]="cardIcon()">
  <hs-form-field>
    <hs-form-label>{{ chooseStatusLabel }}</hs-form-label>
    <hs-select
      [options]="stati()"
      [selectedValue]="selectedOption()"
      [disabled]="!isEditable()"
      (selectionChanged)="onStatusChanged($event)"
    ></hs-select>
  </hs-form-field>

  @for (status of internalHistory(); track status.uId) {
    <div class="flex flex-col w-full pl-2">
      <div>
        {{ getStatusDescription(status) }}
      </div>
      <div>
        {{ getddMMyyyyFormat(status.stampCreate) }}
      </div>
    </div>
  }
</kfm-card>
